 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"AuthLayout":"AuthLayout","ChatPage~FeedPage~FollowsPage~GroupPage~PostPage~SearchPage~UserPage":"ChatPage~FeedPage~FollowsPage~GroupPage~PostPage~SearchPage~UserPage","ContactsPage~FeedPage~FollowsPage~GroupsPage~NotificationsPage~SettingsPage~WalletPage":"ContactsPage~FeedPage~FollowsPage~GroupsPage~NotificationsPage~SettingsPage~WalletPage","FollowsPage":"FollowsPage","NotificationsPage":"NotificationsPage","SettingsPage":"SettingsPage","WalletPage":"WalletPage","DashboardPage~HashtagsPage~ReportsPage~SurveyPage~UsersPage":"DashboardPage~HashtagsPage~ReportsPage~SurveyPage~UsersPage","DashboardPage~UsersPage":"DashboardPage~UsersPage","DashboardPage":"DashboardPage","DefaultLayout":"DefaultLayout","ForgotPasswordPage":"ForgotPasswordPage","LoginPage":"LoginPage","MaintenancePage":"MaintenancePage","NotFoundPage":"NotFoundPage","PrivacyPolicyPage":"PrivacyPolicyPage","RegisterPage":"RegisterPage","ResetPasswordPage":"ResetPasswordPage","VerifyEmailPage":"VerifyEmailPage","AppLayout":"AppLayout","ChatPage~FeedPage~GroupPage~PostPage~SearchPage~UserPage":"ChatPage~FeedPage~GroupPage~PostPage~SearchPage~UserPage","ChatPage":"ChatPage","GroupPage~PostPage~SearchPage~UserPage":"GroupPage~PostPage~SearchPage~UserPage","GroupPage":"GroupPage","PostPage":"PostPage","SearchPage":"SearchPage","UserPage":"UserPage","FeedPage":"FeedPage","ContactsPage":"ContactsPage","GroupsPage":"GroupsPage","HashtagsPage~ReportsPage~SurveyPage~UsersPage":"HashtagsPage~ReportsPage~SurveyPage~UsersPage","UsersPage":"UsersPage","HashtagsPage":"HashtagsPage","ReportsPage":"ReportsPage","SurveyPage":"SurveyPage","RegisterOnboardPage":"RegisterOnboardPage"}[chunkId]||chunkId) + "." + {"AuthLayout":"260218c6","ChatPage~FeedPage~FollowsPage~GroupPage~PostPage~SearchPage~UserPage":"88729987","ContactsPage~FeedPage~FollowsPage~GroupsPage~NotificationsPage~SettingsPage~WalletPage":"cd20444d","FollowsPage":"0f3f2bba","NotificationsPage":"be6e4628","SettingsPage":"e7db6546","WalletPage":"14553628","DashboardPage~HashtagsPage~ReportsPage~SurveyPage~UsersPage":"517bbee7","DashboardPage~UsersPage":"c52b1303","DashboardPage":"14cdf277","DefaultLayout":"864c74d7","ForgotPasswordPage":"5d6df687","LoginPage":"136dd127","MaintenancePage":"9922ac65","NotFoundPage":"579a5064","PrivacyPolicyPage":"ab725fed","RegisterPage":"8ce17c65","ResetPasswordPage":"aaa9be6b","VerifyEmailPage":"27df2e08","chunk-5e9e7b8c":"8a091786","chunk-91a93d1e":"c6d02a33","AppLayout":"1d773943","ChatPage~FeedPage~GroupPage~PostPage~SearchPage~UserPage":"897f154c","ChatPage":"94b0b0ff","GroupPage~PostPage~SearchPage~UserPage":"d0b11e6f","GroupPage":"400605b9","PostPage":"e5959d5b","SearchPage":"66dbf06a","UserPage":"7bd5703a","FeedPage":"fea7f557","ContactsPage":"e4c50350","GroupsPage":"278e0f02","HashtagsPage~ReportsPage~SurveyPage~UsersPage":"3f239948","UsersPage":"f0b281be","HashtagsPage":"d0122d0b","ReportsPage":"308684ab","SurveyPage":"e2035451","RegisterOnboardPage":"7cdfd14a","chunk-7f7cd37e":"5b9f15d7","chunk-a8060334":"93fc04bc","chunk-9efb0524":"e5c79742","chunk-1a2ccfac":"498e7229","chunk-1de87759":"5e5dd089","chunk-2e2e671d":"fc0f6892","chunk-75f8ac95":"eeeffe9a","chunk-2d29f009":"6d1dd2ed","chunk-67b4ad78":"5a7ab16a","chunk-f77b0404":"059930ca"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"AuthLayout":1,"ChatPage~FeedPage~FollowsPage~GroupPage~PostPage~SearchPage~UserPage":1,"ContactsPage~FeedPage~FollowsPage~GroupsPage~NotificationsPage~SettingsPage~WalletPage":1,"FollowsPage":1,"NotificationsPage":1,"SettingsPage":1,"DashboardPage~HashtagsPage~ReportsPage~SurveyPage~UsersPage":1,"DashboardPage":1,"DefaultLayout":1,"ForgotPasswordPage":1,"LoginPage":1,"NotFoundPage":1,"RegisterPage":1,"ResetPasswordPage":1,"chunk-5e9e7b8c":1,"chunk-91a93d1e":1,"AppLayout":1,"ChatPage~FeedPage~GroupPage~PostPage~SearchPage~UserPage":1,"ChatPage":1,"GroupPage~PostPage~SearchPage~UserPage":1,"GroupPage":1,"PostPage":1,"SearchPage":1,"UserPage":1,"FeedPage":1,"ContactsPage":1,"GroupsPage":1,"HashtagsPage~ReportsPage~SurveyPage~UsersPage":1,"UsersPage":1,"ReportsPage":1,"RegisterOnboardPage":1,"chunk-7f7cd37e":1,"chunk-a8060334":1,"chunk-9efb0524":1,"chunk-2d29f009":1,"chunk-f77b0404":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"AuthLayout":"AuthLayout","ChatPage~FeedPage~FollowsPage~GroupPage~PostPage~SearchPage~UserPage":"ChatPage~FeedPage~FollowsPage~GroupPage~PostPage~SearchPage~UserPage","ContactsPage~FeedPage~FollowsPage~GroupsPage~NotificationsPage~SettingsPage~WalletPage":"ContactsPage~FeedPage~FollowsPage~GroupsPage~NotificationsPage~SettingsPage~WalletPage","FollowsPage":"FollowsPage","NotificationsPage":"NotificationsPage","SettingsPage":"SettingsPage","WalletPage":"WalletPage","DashboardPage~HashtagsPage~ReportsPage~SurveyPage~UsersPage":"DashboardPage~HashtagsPage~ReportsPage~SurveyPage~UsersPage","DashboardPage~UsersPage":"DashboardPage~UsersPage","DashboardPage":"DashboardPage","DefaultLayout":"DefaultLayout","ForgotPasswordPage":"ForgotPasswordPage","LoginPage":"LoginPage","MaintenancePage":"MaintenancePage","NotFoundPage":"NotFoundPage","PrivacyPolicyPage":"PrivacyPolicyPage","RegisterPage":"RegisterPage","ResetPasswordPage":"ResetPasswordPage","VerifyEmailPage":"VerifyEmailPage","AppLayout":"AppLayout","ChatPage~FeedPage~GroupPage~PostPage~SearchPage~UserPage":"ChatPage~FeedPage~GroupPage~PostPage~SearchPage~UserPage","ChatPage":"ChatPage","GroupPage~PostPage~SearchPage~UserPage":"GroupPage~PostPage~SearchPage~UserPage","GroupPage":"GroupPage","PostPage":"PostPage","SearchPage":"SearchPage","UserPage":"UserPage","FeedPage":"FeedPage","ContactsPage":"ContactsPage","GroupsPage":"GroupsPage","HashtagsPage~ReportsPage~SurveyPage~UsersPage":"HashtagsPage~ReportsPage~SurveyPage~UsersPage","UsersPage":"UsersPage","HashtagsPage":"HashtagsPage","ReportsPage":"ReportsPage","SurveyPage":"SurveyPage","RegisterOnboardPage":"RegisterOnboardPage"}[chunkId]||chunkId) + "." + {"AuthLayout":"de4dd89f","ChatPage~FeedPage~FollowsPage~GroupPage~PostPage~SearchPage~UserPage":"976ef756","ContactsPage~FeedPage~FollowsPage~GroupsPage~NotificationsPage~SettingsPage~WalletPage":"656d15e6","FollowsPage":"d9a41f95","NotificationsPage":"04fc5a89","SettingsPage":"c4fdebb7","WalletPage":"31d6cfe0","DashboardPage~HashtagsPage~ReportsPage~SurveyPage~UsersPage":"656d15e6","DashboardPage~UsersPage":"31d6cfe0","DashboardPage":"a42ef67c","DefaultLayout":"6453fc36","ForgotPasswordPage":"1d0dd0a4","LoginPage":"dfd15609","MaintenancePage":"31d6cfe0","NotFoundPage":"7aa3ea6c","PrivacyPolicyPage":"31d6cfe0","RegisterPage":"674562ab","ResetPasswordPage":"e282f59a","VerifyEmailPage":"31d6cfe0","chunk-5e9e7b8c":"4223b214","chunk-91a93d1e":"b0404251","AppLayout":"c0e3d471","ChatPage~FeedPage~GroupPage~PostPage~SearchPage~UserPage":"4a67c205","ChatPage":"23287fe0","GroupPage~PostPage~SearchPage~UserPage":"9c494d13","GroupPage":"7ea2275a","PostPage":"2eda590c","SearchPage":"7d83f5da","UserPage":"0fb43a19","FeedPage":"a7cf0845","ContactsPage":"4e5aede4","GroupsPage":"c97f47fc","HashtagsPage~ReportsPage~SurveyPage~UsersPage":"79afb46f","UsersPage":"ff0ee486","HashtagsPage":"31d6cfe0","ReportsPage":"a5358d82","SurveyPage":"31d6cfe0","RegisterOnboardPage":"bbde9487","chunk-7f7cd37e":"cd7011c5","chunk-a8060334":"5717d251","chunk-9efb0524":"5717d251","chunk-1a2ccfac":"31d6cfe0","chunk-1de87759":"31d6cfe0","chunk-2e2e671d":"31d6cfe0","chunk-75f8ac95":"31d6cfe0","chunk-2d29f009":"d59ac40e","chunk-67b4ad78":"31d6cfe0","chunk-f77b0404":"946794be"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
